<template>
  <div v-if="infoData" class="tab-wrapper">
    <h3 class="mb16">解约信息</h3>
    <div class="content">
      <div class="item pt16 pb16">
        <h4 class="mb8">签约信息</h4>
        <Row>
          <Col span="8">合同编号：<span class="info">{{infoData.contractCode}}</span></Col>
          <Col span="8">起租日期：<span class="info">{{formatDateTime(infoData.conStartDate,false)}}</span></Col>
          <Col span="8">到期日期：<span class="info">{{formatDateTime(infoData.conEndDate,false)}}</span></Col>
          <Col span="8">客户姓名：<span class="info">{{infoData.customerName}}</span></Col>
          <Col span="8">联系人电话：<span class="info">{{infoData.userPhone}}</span></Col>


          <Col span="8">签约租期时长：<span class="info">{{infoData.conRentDuration }}</span></Col>
          <Col span="8">实际月租金：<span class="info">{{infoData.actualHousePrice  }}</span></Col>
          <Col span="8">实际服务费：<span class="info">{{infoData.actualServicePrice }}</span></Col>
          <Col span="8">付款方式：<span class="info">{{typeMap[infoData.conCycleCode+'' ]}}</span></Col>
        </Row>
      </div>

      <div class="item pt16 pb16">
        <h4 class="mb8">解约信息</h4>
        <Row>
          <Col span="8">解约协议号：<span class="info">{{infoData.surCode}}</span></Col>
          <Col span="8">解约申请日期：<span class="info">{{formatDateTime(infoData.surApplicationDate,false)}}</span></Col>
          <Col span="8">退租原因：<span class="info">{{infoData.surReason}}</span></Col>
          <Col span="8">解约类型：<span class="info">{{infoData.surTypeName}}</span></Col>
          <Col span="8">解约日期：<span class="info">{{formatDateTime(infoData.surReleaseDate,false)}}</span></Col>
          <Col span="8">实际退租日期：<span class="info">{{formatDateTime(infoData.surReleaseDate,false)}}</span></Col>
          <Col span="8">实际租期时长：<span class="info">{{infoData.actConRentDuration }}</span></Col>
          <Col span="8">租金应缴至：<span class="info">{{formatDateTime(infoData.surRentPriceDate,false)}}</span></Col>
          <Col span="8">服务费应缴至：<span class="info">{{formatDateTime(infoData.surRentPriceDate,false)}}</span></Col>
          <Col span="8">解约ZO：<span class="info">{{infoData.handleZo}}</span></Col>
        </Row>
      </div>

      <div class="item pt16 pb16" v-if="infoData.changeContractCode">
        <h4 class="mb8">换租信息</h4>
        <Row>
          <Col span="8">换租合同：<span class="info">{{infoData.changeContractCode}}</span></Col>
          <Col span="8">产品线：<span class="info">{{infoData.changeContractSource}}</span></Col>
          <Col span="8">项目名：<span class="info">{{infoData.changeProjectName}}</span></Col>
          <Col span="8">房间号/床位号：<span class="info">{{infoData.changeHouseNumber}}</span></Col>
          <Col span="8">签约客户：<span class="info">{{infoData.changeCustomerName}}</span></Col>
          <Col span="8">签约手机号：<span class="info">{{infoData.changeCustomerPhone}}</span></Col>
          <Col span="8">起租日期：<span class="info">{{formatDateTime(infoData.changeStartDate,false)}}</span></Col>
          <Col span="8">到期日期：<span class="info">{{formatDateTime(infoData.changeEndDate,false)}}</span></Col>
        </Row>
      </div>
      <div class="item pt16 pb16" v-if="infoData.subletCustomerName">
        <h4 class="mb8">转租信息</h4>
        <Row>
          <Col span="8">姓名：<span class="info">{{infoData.subletCustomerName}}</span></Col>
          <Col span="8">手机号：<span class="info">{{infoData.subletCustomerPhone}}</span></Col>
          <Col span="8">证件类型：<span class="info">{{infoData.subletCardTypeName}}</span></Col>
          <Col span="8">证件号：<span class="info">{{infoData.subletCustomerCertNum}}</span></Col>
        </Row>
      </div>
    </div>
  </div>

</template>

<script type="text/ecmascript-6">
  import {formatDateTime} from '@/utils/format'
  import TableList from "components/TableList/index";

  export default {
    props: {
      infoData: {
        type: Object,
        default: null
      }
    },
    components: {
      TableList
    },
    data() {
      return {
        typeMap: {
          "1": "月付",
          "3": "季付",
          "6": "半年付",
          "12": "年付",
          "9": "一次性付清"
        }
      };
    },
    methods: {
      formatDateTime: formatDateTime

    }
  }
</script>
<style scoped>

  .ivu-row, p {
    line-height: 3;
  }

  .info {
    padding-left: 8px;
    font-weight: 600;
  }
</style>

